import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import serverEndPoint from './../../dxdm';
import './OurPeople.css';
const sideBoxes = {
    height: "200pt",
    width: "100%",
    backgroundColor: "rgb(233,241,246)",
    marginTop: "10%",
    marginBottom: "10%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}
const category = {
    marginLeft: "5%",
    paddingBottom: "3%",
    borderBottom: "1px solid gray",
}
const buttonCSS = { borderRadius: "20pt", textAlign: "center", paddingLeft: "10%", paddingRight: "10%" }
export default class OurPeople extends Component {
    render() {
        return (
            <div style={{ textAlign: "left" }}>
                <div className="row">
                    <div className="col-sm-12" style={{ padding: "5%" }}>
                        <h1 style={{ color: "rgb(40,109,181)" }}>People</h1>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-2"></div>
                    <div className="col-lg-3">
                        <div className="personSlideMaster">
                            <a style={{ textDecoration: "none" }} target="_blank" rel="noreferrer" href="http://isb.nu.edu.pk/asif/">
                                <table style={{
                                    height: "100%", width: "100%",
                                }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundImage: `url(${serverEndPoint}/images/asif_new.jpg)`, width: "310px", height: "310pt", backgroundSize: "cover", backgroundPosition: "left", backgroundRepeat: "no-repeat" }}>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                <div>
                                                    <div style={{ fontWeight: "bold", fontSize: "16pt" }}>Professor M. Asif Naeem</div>
                                                    <i style={{ fontSize: "12pt", fontWeight: "bold" }}>Founder and Director</i>
                                                    <p style={{ fontSize: "10pt" }}>Professor Muhammad Asif Naeem is founder and director of Data Insight Lab at National University FAST, Islamabad.
                                                        He is also founder of Data Science Research Group (DSRG) at Auckland University of Technology, New Zealand. His research interests include Data Science,
                                                        Big Data Management, Data Mining and Machine Learning, Active Databases and Data Warehousing. Click to read more about him.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </a>
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-4">
                        <div style={sideBoxes}>
                            <div style={{ width: "70%", }}>
                                <div >
                                    <h3 style={{ color: "rgb(40,109,181)" }}>Study with us</h3>
                                    <p>Our research spectrum is in data and knowledge engineering. We invite you to study your PhD with us.</p>
                                    <Link className="btn btn-primary" to={`/studywithus`} style={buttonCSS}> <b>FIND OUT MORE</b> </Link>
                                    {/* <Link className="btn btn-primary" to={`${serverEndPoint}/studywithus`} style={buttonCSS}> <b>FIND OUT MORE</b> </Link> */}
                                </div>
                            </div>
                        </div>
                        <div style={sideBoxes}>
                            <div style={{ width: "70%", }}>
                                <div >
                                    <h3 style={{ color: "rgb(40,109,181)" }}>Our research</h3>
                                    <p> Data science is an area of extensive research as new applications are emerging from Industry.</p>
                                    <Link className="btn btn-primary" to={`/our-research`} style={buttonCSS}> <b>FIND OUT MORE</b> </Link>
                                    {/* <Link className="btn btn-primary" to={`${serverEndPoint}/our-research`} style={buttonCSS}> <b>FIND OUT MORE</b> </Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-1"></div>
                </div>

                <br />
                <div className="row">
                    <div className="col-lg-12">

                        <h2 style={{ category, color: "rgb(40,109,181)", marginLeft: "35pt" }}>International Collaborators</h2>
                        <ul style={{ display: "flex", flexWrap: "wrap" }}>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://www.linkedin.com/in/david-parry-he-him-7700b011/?originalSubdomain=nz">

                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/DaveDerryc.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Professor Dave Parry</h5>
                                                        <div style={{ fontSize: "10pt" }}>
                                                            Professor Dave Parry PhD, is head of the IT, Media and Communications discipline at
                                                            Murdoch University, Perth. His research interests include Ontologies and fuzzy logic, Health
                                                            informatics and computer-based Activity detection in the context of health, wellness and
                                                            procedural error. He is particularly interested in how machine-learning and knowledge-based
                                                            approaches can be used to make a difference in clinical outcomes
                                                        </div>
                                                        {/* <a style={{ marginTop: "1vh" }} href="https://www.linkedin.com/in/david-parry-he-him-7700b011/?originalSubdomain=nz" className="btn btn-sm btn-light">Dave's Website</a> */}

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://academics.aut.ac.nz/farhaan.mirza/about">
                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/FarhaanMirzac.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Dr Farhaan Mirza</h5>
                                                        <div style={{ fontSize: "10pt" }}>
                                                            Dr Farhaan Mirza is director of Data Science Research Group (DSRG) at Auckland University of Technology. He is senior lecturer in the department of IT & Software Engineering at Auckland University of Technology. Farhaan’s passion is to use Internet of things (IoT), mobile apps, web technologies along with big data to develop applications for public sector development, specifically towards domains of healthcare, transportation, education, and telecommunications
                                                        </div>
                                                        {/* <a style={{ marginTop: "1vh" }} href="https://academics.aut.ac.nz/farhaan.mirza/about" className="btn btn-sm btn-light">Farhaan's Website</a> */}

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://academics.aut.ac.nz/roopak.sinha">
                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/RoopakSinhac.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Dr Roopak Sinha</h5>
                                                        <div style={{ fontSize: "10pt" }}>
                                                            Dr Roopak Sinha (Ph.D. ’09, MCE ’16, BE (Hons) ’03, SFHEA ’17) is the Head of the Department of Computer Science and Software Engineering at Auckland University of Technology, New Zealand. Roopak’s primary research interest is ‘‘Systematic, Standards-First Design of Complex, Next-Generation Software’’ applied to domains like Internet-of-Things, Edge Computing, Cyber-Physical Systems, Big-Data, Home and Industrial Automation, and Intelligent Transportation Systems.
                                                        </div>
                                                        {/* <a style={{ marginTop: "1vh" }} href=": https://academics.aut.ac.nz/roopak.sinha" className="btn btn-sm btn-light">Roopak's Website</a> */}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://unidirectory.auckland.ac.nz/profile/g-weber">
                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/Geraldc.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Dr Gerald Weber</h5>
                                                        <div style={{ fontSize: "10pt" }}>
                                                            Dr Gerald Weber is Senior Lecturer in the Department of Computer Science at The University of Auckland. He joined The University of Auckland in 2003. Gerald holds a PhD from the FU Berlin. He is information director of the Proceedings of the VLDB Endowment, and he has been program chair of several conferences. He is co-author of the book “Form-Oriented Analysis”, and of over 40 peer-reviewed publications.

                                                        </div>
                                                        {/* <a style={{ marginTop: "1vh" }} href="https://unidirectory.auckland.ac.nz/profile/g-weber" className="btn btn-sm btn-light">Gerald's Website</a> */}

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://www.cs.auckland.ac.nz/~asghar">
                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/Asgharc.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Rizwan Asghar</h5>
                                                        <div style={{ fontSize: "10pt" }}>
                                                            Auckland (UoA). He holds a PhD degree from the University of Trento (Italy). As part of his PhD programme, he was a Stanford Research Institute Fellow at SRI International, California, USA. Prior to joining UoA, he was a Postdoctoral Researcher at international research institutes including CISPA (Germany) and CREATE-NET (Italy). During his career, he also worked as a Software Engineer at international software companies. His research interests include access control, cybersecurity, privacy, and applied cryptography.

                                                        </div>
                                                        {/* <a style={{ marginTop: "1vh" }} href="https://unidirectory.auckland.ac.nz/profile/g-weber" className="btn btn-sm btn-light">Gerald's Website</a> */}

                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>
                        </ul>
                        <h2 style={{ category, color: "rgb(40,109,181)", marginLeft: "35pt" }}>Local Collaborators</h2>
                        <ul style={{ display: "flex", flexWrap: "wrap" }}>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://igis.nust.edu.pk/faculty/muhammad-ali-tahir/">
                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/Alic.jpg)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Dr Ali Tahir</h5>
                                                        <div style={{ fontSize: "1.4vh" }}>
                                                            Dr Ali did his PhD in Geoinformatics from the School of Computer Science and Informatics at University College Dublin, Ireland. His research activities include implicit feedback analysis, Geo-visualisation, and Web GIS. Currently he is serving as an Assistant Professor at IGIS-NUST and also heading GIS Mobility Lab as part of NUST Interdisciplinary Cluster for Higher Education (NICHE).
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>
                            <li className="personSlide">
                                <a target="_blank" rel="noreferrer" href="https://smme.nust.edu.pk/faculty/syed-omer-gilani/">
                                    <table style={{
                                        height: "100%", width: "100%",
                                    }}>
                                        <tbody>
                                            <tr>
                                                <td style={{ backgroundImage: `url(${serverEndPoint}/images/Omerc.jpg)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                    <div>
                                                        <h5>Dr Syed Omer Gilani</h5>
                                                        <div style={{ fontSize: "1.4vh" }}>
                                                            Dr. Gilani is a tenured Associate Professor and Head of the Department at Biomedical Engineering and Sciences in NUST.  He has generated over 4 MPKR in consultancy and has research funding of over 10 MPKR, including one HEC NRPU project. He has published over 100 research papers, 4 book chapters, and 1 US patent and has H-index of 18. His research interests include computer vision, medical signal and image analysis, machine learning, computer graphics, control systems, and electronics.
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </a>
                            </li>

                        </ul>


                        <h2 style={{ category, color: "rgb(40,109,181)", marginLeft: "35pt" }}>International Students</h2>
                        <ul style={{ display: "flex", flexWrap: "wrap" }}>
                            <li className="personSlide">
                                <table style={{
                                    height: "100%", width: "100%",
                                }}>
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundImage: `url(${serverEndPoint}/images/Bejaminc.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                                <div>
                                                    <h5>Benjamin Denham</h5>
                                                    <div style={{ fontSize: "10pt" }}>
                                                        Benjamin is a PhD candidate at the AUT undertaking industry-based research into machine learning methods that leverage domain expertise to compensate for imperfect training datasets. His research interests include natural language processing, interpretable models, weak supervision, and machine learning with small or otherwise limited datasets. Benjamin's background is in software engineering, with 10 years of industry experience in web application development.
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </li>
                            <li className="personSlide"><table style={{
                                height: "100%", width: "100%",
                            }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundImage: `url(${serverEndPoint}/images/Warunic.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                            <div>
                                                <h5>Waruni Hewage</h5>
                                                <div style={{ fontSize: "10pt" }}>
                                                    Waruni Hewage is a PhD student at the Auckland University of Technology. She is working on topic “Balancing the accuracy of data and people’s right to privacy” under the supervision of Associate Professor Roopak Sinha, Professor Edmund Lai and Professor Muhammad Asif Naeem. The primary goal of her research is to generate a framework to optimise the trade-off between privacy and accuracy to help users achieve good accuracy while maintaining the privacy of the data.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table></li>
                            <li className="personSlide"><table style={{
                                height: "100%", width: "100%",
                            }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundImage: `url(${serverEndPoint}/images/Darshac.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                            <div>
                                                <h5>Darsha Jayamini</h5>
                                                <div style={{ fontSize: "10pt" }}>
                                                    Darsha Jayamini is a PhD student at the Auckland University of Technology, New Zealand. The topic of her PhD is “   ”. She earned her bachelor’s degree specialized in Computer Science with a first class from the University of Kelaniya, Sri Lanka.
                                                    She is also working as a Lecturer (Probationary) in the Department of Software Engineering, Faculty of Computing ad Technology, University of Kelaniya, Sri Lanka. Becoming an outstanding researcher and academic is her goal.

                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table></li>
                            <li className="personSlide"><table style={{
                                height: "100%", width: "100%",
                            }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundImage: `url(${serverEndPoint}/images/Rashic.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                            <div>
                                                <h5>Rashi Bhalla</h5>
                                                <div style={{ fontSize: "10pt" }}>
                                                    Rashi is a PhD student at the Auckland University of Technology, New Zealand.  She is specializing in distributed data stream mining and is working towards building a prediction model for Asthma. Her interests are in Data Mining and Machine Learning.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table></li>
                        </ul>
                        <h2 style={{ category, color: "rgb(40,109,181)", marginLeft: "35pt" }}>Local Students</h2>
                        <ul style={{ display: "flex", flexWrap: "wrap" }}>
                            <li className="personSlide"><table style={{
                                height: "100%", width: "100%",
                            }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundImage: `url(${serverEndPoint}/images/Waheedc.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                            <div>
                                                <h5>Waheed Ashraf</h5>
                                                <div style={{ fontSize: "10pt" }}>
                                                    Muhammad Waheed Ashraf is a PhD scholar at National University of Computer and Emerging Sciences (NUCES), Islamabad.  He has worked as Research Assistant on a project “Deep Basket Analysis” where he developed his expertise in the areas of Data Mining, Machine Learning, and Computer vision. He has good expertise and understanding of domain knowledge required in this project.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table></li>
                            <li className="personSlide"><table style={{
                                height: "100%", width: "100%",
                            }}>
                                <tbody>
                                    <tr>
                                        <td style={{ backgroundImage: `url(${serverEndPoint}/images/Zaeemc.png)`, width: "200px", height: "240pt", backgroundSize: "cover" }}>

                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "15pt", color: "white", textAlign: "justify", display: "flex", alignItems: "flex-start" }}>
                                            <div>
                                                <h5>Zaeem Ahmad</h5>
                                                <div style={{ fontSize: "10pt" }}>
                                                Assistant Director in Ministry of Science and Technology, Pakistan Engineering Council. Graduated in computer sciences from COMSATS Islamabad then did his master’s in computer sciences from NUCES-FAST and currently a PHD scholar in NUCES-FAST.Worked as professional software developer since 2008 and worked in various private and government organizations. With his accomplished career he is also interested in deep neural architectures for predictive and descriptive analytics. He has worked on different projected related to practical software development developed in different languages i.e., PHP, C# and SQL, .NET, Laravel & Yii.
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table></li>
                        </ul>
                    </div>


                </div>
            </div>
        )
    }
}
